import { Gps } from '../../pages/arc/models/arc-epi-props';
import { BaseBlockModel, RedesignAnnouncementBlock, TcsmNewsUpdateBlock } from './tcsm-block-models';

export enum PageType {
	TCSMLandingPage = 'TCSMLandingPage',
	TCSMNewsUpdatesPage = 'TCSMNewsUpdatesPage',
	NotFoundPage = 'NotFoundPage',
	TCSMReportsLandingPage = 'TCSMReportsLandingPage',
	TCSMContentPage = 'TCSMContentPage',
	RedesignNewsUpdatesPage = 'RedesignNewsUpdatesPage',
}
export interface BasePageModel {
	pageType: string | PageType;
	pageTitle: string;
}

export interface TcsmLandingPage extends BasePageModel {
	linkSectionContent: BaseBlockModel[];
	guidesAndResourcesTitle: string;
	guidesAndResourceContent: BaseBlockModel[];
	guidesAndResourcesOptionalDescription: string;
	landingPageGpsTitle: string;
	landingPageGps: Gps[];
	showPortalBanner?: boolean;
	sideBarOptionalContent?: string;
	sideBarOptionalContentTitle?: string;
}

export interface TcsmNewsUpdatesPage extends BasePageModel {
	newsAndUpdatesMessage: string;
	topicsOfInterestHeader: string;
	newsUpdatesItems: TcsmNewsUpdateBlock[];
	guidesAndResourcesTitle: string;
	guidesAndResourceContent: BaseBlockModel[];
	guidesAndResourcesOptionalDescription: string;
	newsUpdatesGpsTitle: string;
	newsUpdatesGps: Gps[];
}

export interface TcsmNotFoundPage extends BasePageModel {
	mainContent: string;
}

export interface RedesignNewsUpdatesPage extends BasePageModel {
	announcements: RedesignAnnouncementBlock[];
	viewMoreButtonText: string;
	noMoreAnnouncementsText: string;
}

export interface TcsmReportsLandingPage extends TcsmLandingPage {
	// Benefits Group
	benefitsGroupTitle: string;
	benefitsGroupDescription: string;
	benefitsGroupActionLabel: string;

	// Billing Account
	billingAccountTitle: string;
	billingAccountDescription: string;
	billingAccountActionLabel: string;

	// Institution
	institutionTitle: string;
	institutionDescription: string;
	institutionActionLabel: string;

	// Diocesan
	diocesanTitle: string;
	diocesanDescription: string;
	diocesanActionLabel: string;
}

export interface TcsmContentPage extends BasePageModel {
	mainContent: string;
	contentArea: BaseBlockModel[];
	gpsTitle: string;
	gps: Gps[];
	footerLinkTitle: string;
	footerLink: string;
}
